// extracted by mini-css-extract-plugin
export var calender_wrapper = "webinarCalendar-module--calender_wrapper--c8aa1";
export var col_6 = "webinarCalendar-module--col_6--e0864";
export var img_bg = "webinarCalendar-module--img_bg--69689";
export var quoteImage = "webinarCalendar-module--quoteImage--e02c7";
export var ul_list = "webinarCalendar-module--ul_list--d69a8";
export var ul_title = "webinarCalendar-module--ul_title--12b52";
export var webinarcalender = "webinarCalendar-module--webinarcalender--3e17b";